<p-dialog header="{{currentModuleName}} Data Export" (onHide)="cancelExport()" [(visible)]="displayExport"
 [modal]="true" [responsive]="true" [maximizable]="false" [style]="{width: '30%', minWidth: '30%'}">

    <app-subscription-limit-message
        *ngIf="subscriptionLimitReached"
        [subscriptionLimit]="subscriptionLimit"
        [moduleName]="'Export'">
    </app-subscription-limit-message>

  <div *ngIf="!subscriptionLimitReached" class="p-grid" style="height: 400px;">

    <div class="p-col-12 p-lg-12">
      <div class="card">

        <div>
          <div class="p-d-flex">
            <div>
              <h6>Choose Export Columns</h6>
            </div>
          </div>
          <div class="p-d-flex">
            <div>
              <div>
                <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields"
                  [(ngModel)]="listSearchInput">
              </div>
              <div class="p-d-flex p-ai-center gap-1 p-mt-2 ml-custom">
                <p-checkbox 
                        binary="true"
                        inputId="binary"
                        class="p-mr-2"
                        (onChange)="enableAllSectionFields($event,currentallListColumns)">
                </p-checkbox>
                <label for="binary"><strong>Select All Fields</strong></label>
            </div>
              <ng-container *ngFor="let section of currentallListColumns; let idx = index">
                <hr style="margin: 0.5rem;">
                <div class="section-header ml-custom">
                  <h6 class="sectionLabel">
                    <span>
                      <p-checkbox type="checkbox" binary="true" inputId="binary" [disabled]="isSelectAllSectionField" class="p-mr-1"
                        (onChange)="enableSectionFields($event,section)">
                      </p-checkbox>
                    </span>
                    <span>
                      {{section.name}}
                    </span>
                  </h6>
                </div>
                <div class="sub-columns" cdkDropList [cdkDropListData]="section.fields"
                  (cdkDropListDropped)="dropCol($event, 'listView', idx)">
                  <ng-container *ngFor="let col of section.fields | gblFilter: listSearchInput: 'name' ; let i = index">
                    <div class="colList" cdkDrag [cdkDragDisabled]="!col.dragable" appendTo="body" *ngIf="col.name">
                      <div class="p-d-flex">
                        <i class="fa fa-bars p-mt-1" *ngIf="col.dragable" style="margin-right: 10px; color:lightgray"></i>
                        <i class="fa fa-minus p-mt-1" *ngIf="!col.dragable" style="margin-right: 10px; color:lightgray"></i>
                        <p-checkbox [(ngModel)]="col.enabled" *ngIf="col?.childFields?.length === 0" type="checkbox" binary="true"
                          inputId="binary" [disabled]="((!col.enabled && maxCheckedFieldForList))"
                          class="p-mr-2">
                        </p-checkbox>
                        <span class="p-mt-1">{{col.name}}</span>
                        <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain p-ml-2"
                          [icon]="col.showChildrens ? 'pi pi-minus' : 'pi pi-plus'" *ngIf="col?.childFields?.length > 0"
                          (click)="showChild(col)" style="height: 20px; width: 20px;"></button>
                      </div>
                      <div *ngIf="col?.showChildrens && col?.childFields.length > 0">
                        <ul>
                          <li *ngFor="let childCol of col.childFields">
                            <p-checkbox [(ngModel)]="childCol.enabled" type="checkbox" binary="true" inputId="binary"
                              [disabled]="((!childCol.enabled && maxCheckedFieldForList))"
                              class="p-mr-2"></p-checkbox>
                            {{childCol.name}}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button (click)="cancelExport()" label="Cancel" styleClass="p-button-secondary"></p-button>
    <p-button *ngIf="!subscriptionLimitReached" (click)="exportData()" label="Export"></p-button>
  </ng-template>
</p-dialog>

  <p-dialog header="Export Confirmation" [(visible)]="showExportFileType" [style]="{width: '380px'}" [modal]="true">
    <div class="p-d-flex">
        <i class="pi pi-info-circle"></i>
        <span class="p-ml-2">Do you want to export {{currentModuleName}} Data?</span>
    </div>
    <p-footer>
        <button type="button" pButton icon="pi pi-file-pdf" label="PDF" (click)="downloadSavedSearch('Pdf')"></button>
        <button type="button" pButton icon="pi pi-file-excel" label="CSV" (click)="downloadSavedSearch('Csv')"></button>
        <button type="button" pButton icon="pi pi-file-excel" label="XLSX" (click)="downloadSavedSearch('Excel')"></button>
    </p-footer>
</p-dialog>
